<template>
  <div>
    <el-dialog
      :title="$l('dialog_select_fabric_stock') || '选择面料库存'"
      :visible.sync="dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      width="1000px"
      top="10vh"
    >
      <page-main
        ref="main"
        v-if="dialogVisible"
        :loading="loading"
        :table-data="table"
        :tablePage="page"
        @saveChooseCode="saveChooseCode"
      >
        <page-header
          @reset="reset"
          @submit="handleSubmit"
          @chooseCode="chooseCode"
          slot="header"
          ref="header"
        />
        <pagination
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          size="small"
          align="right"
          slot="pager"
          @change="handlePaginationChange"
        />
      </page-main>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
  },
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main'),
  },
  data() {
    return {
      dialogVisible: false,
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
    }
  },
  methods: {
    chooseCode() {
      this.$refs.main.chooseCode()
    },
    //选择藏品返回数据
    saveChooseCode(codeList) {
      this.$emit('saveChooseCode', codeList)
      this.close()
    },
    load() {
      setTimeout(() => {
        this.$refs.header.query()
      }, 0)
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      }
    },
    submitSuccess() {
      this.dialogVisible = false
      this.$emit('success')
    },
    reload() {
      this.$refs.header.query()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    //加载数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .fabricStockChoiceApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
